import { render, staticRenderFns } from "./editor-partial.vue?vue&type=template&id=326cf2d8"
import script from "./editor-partial.vue?vue&type=script&lang=js"
export * from "./editor-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports